export const environment = {
  X_TENANT_ID: '',
  orchUrl: '//orchestrator-ni-los-uat.financinguat.network.ae/',
  // orchUrl: '//orchestrator-ni-los-uat.financeuat.ads.network.ae/',

  config_from_api: false,
  production: false,
  instance: 'uat',
  client_folder: 'ni',
  custom_feature : true,
  asset_path: 'assets/',
  login_logo_path: '../../../assets/images/network_logo.svg',
  products_enabled: ['businessloans'],
  retryInterceptor: true,
  otp_resend_time : 90,

  region: 'uae',
  country: 'ae',
  currencySymbol: 'AED',
  countryCode: '+971',
  emirateCode: '784-',
  secure: true,
  timezone: 'EDT',
  cdnURL: '../../../assets/',
  widgetCDN: '/assets/js/widget.min.js',
  journeyType: 'customer-journey',
  customerJourneyUrl: 'https://customer-ni-los-uat.financinguat.network.ae',
  // customerJourneyUrl: 'https://customer-ni-los-uat.financeuat.ads.network.ae',
  banker_url: 'https://banker-ni-los-uat.financeuat.ads.network.ae',
  logo1_path:'../../../assets/images/network_logo.svg',
  logo2_path:'https://d3959x4byuoxpr.cloudfront.net/images/de84b90f-a814-4fdb-a50f-98aeee45e694-images-original.svg',
  powered_by_logo: 'https://d3959x4byuoxpr.cloudfront.net/images/ad796e9e-f100-450a-aaa7-dab04dee4e10-images-original.svg',
  logo3_path : 'https://d3959x4byuoxpr.cloudfront.net/images/2e8d203b-a2f9-45db-8bc7-b6408390e2d0-images-original.svg',
  title: 'Network International',
  client_name: 'Network International',
  mail_client_name: 'Network International',
  project_name: 'Network International',
  client_addressl: '',
  client_city: '',
  client_state: '',
  client_zipcode: '',
  client_country: 'UAE',
  client_email: 'support@b2cdev.com',
  copyright_text: 'Network International',
  client_url: '',
  client_number: '',
  client_lender_id: '',
  brand_id: '',
  privacy: 'https://www.network.ae/en/contents/view/who-we-are',
  siteMap: 'https://www.biz2x.com',
  terms: 'https://www.network.ae/en/faqs',
  noreplymail: 'donotreplybusinessloans@b2cdev.com',
  support_mail: "",
  REQUEST_CHECKSUM_SECRET: "9c48af5580c2116c3a00127f7649b8b937c20716756158a936d29d21d1a85a81",
  offer_sign_url: 'https://dw0q1hi7p7ayu.cloudfront.net/images/660c52e2-8020-4c49-9b02-9485a4fc91eb-Biz2X-original.png'
};
